<template>
	<div v-if="activeWidget">
		<template v-if="activeWidget.content.type == 'map' && activeWidget.content.data && activeWidget.content.data.myMap">
			<MyTabs
				:tabs="tabs"
				:data="activeWidget.content.data"
				:uniqueKey="uniqueKey"
			/>
		</template>
		<template v-else-if="activeWidget.content.type == 'text'">
			<TextEditor
				v-bind:content="activeWidget.content.data"
				v-bind:onSave="onTextSave"
				class="ma-2"
			/>
		</template>
	</div>
	<div
		v-else-if="widgetsCount > 1"
		class="ma-3"
	>
		Aktyvuokite dominantį valdiklį pieštuko įrankiu!
	</div>
</template>

<script>
	import TextEditor from "../../../TextEditor";
	import MyTabs from "./MyTabs";

	export default {
		props: {
			cfg: Object
		},
		computed: {
			activeWidget: {
				get: function(){
					console.log("Pasikeitė activeWidget'as...", this.$store.state.activeWidget);
					return this.$store.state.activeWidget;
				}
			},
			widgetsCount: {
				get: function(){
					var widgetsCount;
					if (this.cfg && this.cfg.grid) {
						widgetsCount = this.cfg.grid.cols*this.cfg.grid.rows;
					}
					return widgetsCount;
				}
			}
		},
		data: function(){
			var data = {
				tabs: [{
					title: "Turinys",
					component: "map-layers"
				},{
					title: "Paieška",
					component: "service-search"
				},{
					title: "Nustatymai",
					component: "settings"
				}],
				uniqueKey: 0
			};
			return data;
		},
		components: {
			TextEditor,
			MyTabs
		},
		methods: {
			onTextSave: function(){
				if (this.widgetsCount > 1) {
					this.$store.commit("setActiveWidget", null);
				}
			}
		},
		watch: {
			activeWidget: {
				handler: function(){
					this.uniqueKey += 1;
				}
			}
		}
	}
</script>